import React from 'react';
import { render } from 'react-dom';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import { AppRoute } from './utilities/http/routing/AppRoute';
import { NotFound } from './components/Pages/NotFound';
import { HomePage } from './components/Pages/HomePage';
import Logout from './utilities/http/routing/Logout'; // Import the Logout component
import './css/main.css';
import './css/driving-controls.css';
import './css/path-planning.css';
import './css/video.css';
import './css/widgets.css';
import './css/robot-status.css';
import './css/toolbars.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ScreenResolutionProvider } from './services/General/ScreenResolutionProvider';
import AuthCallback from './utilities/http/routing/AuthCallback'; // Import the callback component
import { AuthProvider } from './utilities/http/routing/AuthContext';
import { ObserverProvider } from './utilities/http/routing/ObserverContext';
import { OperatorProvider } from './utilities/http/routing/OperatorContext';
import { EmailProvider } from './utilities/http/routing/EmailContext';
import { MaintenanceProvider } from './utilities/http/routing/MaintenanceContext';
import { UserManagerProvider } from './utilities/http/routing/UserManagerContext';
import {RobotDetailsProvider} from './utilities/RobotDetailsContext';
import { StopSearchProvider } from './utilities/http/routing/StopSearchContext';

const MainLayout = props => (
  <>
    {props.children}
  </>
);

render((
  <RobotDetailsProvider>
    <BrowserRouter>
      <UserManagerProvider>
        <AuthProvider>
          <EmailProvider>
            <OperatorProvider>
              <ObserverProvider>
                <MaintenanceProvider>
                  <StopSearchProvider>
                    <React.StrictMode>
                      <Switch>
                        <ScreenResolutionProvider>
                          <AppRoute exact path="/:robot" layout={MainLayout} component={HomePage} />
                          <Route path="/auth/callback/:robot" component={AuthCallback} />
                          <Route path="/:robot/logout" component={Logout} />
                          <AppRoute layout={MainLayout} component={NotFound}/>
                        </ScreenResolutionProvider>
                      </Switch>
                    </React.StrictMode>
                  </StopSearchProvider>
                </MaintenanceProvider>
              </ObserverProvider>
            </OperatorProvider>
          </EmailProvider>
        </AuthProvider>
      </UserManagerProvider>
    </BrowserRouter>
  </RobotDetailsProvider>
), document.getElementById('root'));
